// Must stay in sync with Tailwind's @theme breakpoints in globals.css —
// JS and CSS each carry their own copy.
const breakpoints = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px',
} as const;

export type BreakpointKey = keyof typeof breakpoints;

export default breakpoints;

export function getMediaQueries() {
  const mediaQueries: Record<string, MediaQueryList> = {};

  (Object.keys(breakpoints) as BreakpointKey[]).forEach((breakpoint) => {
    const breakpointValue = breakpoints[breakpoint];
    mediaQueries[breakpoint] = window.matchMedia(`(min-width: ${breakpointValue})`);
  });

  return mediaQueries;
}
